module.exports = __webpack_public_path__ + "jm.svg?3053a605fca4ce752bf47d75f65b0552";